import React, { useEffect } from "react";
import {
  BlockTypeSelect,
  // BlockTypeSelect,
  BoldItalicUnderlineToggles,
  // CreateLink,
  frontmatterPlugin,
  headingsPlugin,
  imagePlugin,
  InsertTable,
  // InsertTable,
  linkDialogPlugin,
  linkPlugin,
  listsPlugin,
  ListsToggle,
  MDXEditor,
  quotePlugin,
  Separator,
  tablePlugin,
  thematicBreakPlugin,
  toolbarPlugin,
  UndoRedo,
} from "@mdxeditor/editor";
import "@mdxeditor/editor/style.css";
import classNames from "classnames";

interface RichTextEditorProps {
  markdown: string;
  readonly?: boolean;
  allowTextSizeChange?: boolean;
  wrapperClassName?: string;
  onChange?: (value: string) => void;
}

const RichTextEditor = (props: RichTextEditorProps) => {
  const {
    markdown,
    readonly,
    allowTextSizeChange = true,
    wrapperClassName,
    onChange,
  } = props;

  const [value, setValue] = React.useState(markdown);

  useEffect(() => {
    if (markdown !== value) {
      setValue(markdown);
    }
  }, [markdown, value]);

  const handleOnChange = (value: string) => {
    onChange?.(value);
  };

  const richTextClassName = classNames("dui-rich-text-editor", {
    "dui-rich-text-readonly": readonly,
    "dui-rich-text-editor-dark": localStorage.getItem("theme") === "dark",
  });

  console.log(markdown);

  return (
    <div className={wrapperClassName}>
      <MDXEditor
        key={value}
        markdown={value}
        readOnly={readonly}
        className={richTextClassName}
        contentEditableClassName="dui-rich-text-inner"
        plugins={[
          toolbarPlugin({
            toolbarClassName: "dui-rich-text-toolbar",
            toolbarContents: () => (
              <>
                <UndoRedo />
                <Separator />
                <BoldItalicUnderlineToggles />
                <Separator />
                <ListsToggle />
                <Separator />
                <InsertTable />
                {
                  /* <Separator />
                <CreateLink />
                <Separator />
                */
                  allowTextSizeChange ? <BlockTypeSelect /> : null
                }
              </>
            ),
          }),
          listsPlugin(),
          thematicBreakPlugin(),
          quotePlugin(),
          headingsPlugin({ allowedHeadingLevels: [1, 2, 3] }),
          linkPlugin(),
          linkDialogPlugin(),
          imagePlugin({
            imageAutocompleteSuggestions: [
              "https://via.placeholder.com/150",
              "https://via.placeholder.com/150",
            ],
          }),
          tablePlugin(),
          thematicBreakPlugin(),
          frontmatterPlugin(),
        ]}
        onChange={handleOnChange}
      />
    </div>
  );
};

export default RichTextEditor;
